import React, { useEffect, useState } from "react";
import {
  GetSalesVoucherList,
  GetSalesVoucherById,
  SalesVoucherUpdate,
  SalesVoucherCreate,
  SalesVoucherDelete,
  ApproveSolistapi,
  fetchParty,
  ApproveSalesVoucher,
  GenerateSalesVoucherNo,
} from "../../../Services/Services";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  Modal,
  Box,
  TextField,
  MenuItem,
  Popover,
  Typography,
  Checkbox,
  Autocomplete,
  Grid,
  Chip,
  useMediaQuery,
  useTheme,
  Collapse,
  Divider,
  Menu,
} from "@mui/material";
import {
  Edit,
  Delete,
  Print,
  Visibility,
  Add,
  Close,
  ExpandMore,
  ExpandLess,
} from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import AddIcon from "@mui/icons-material/Add";
import { toast, ToastContainer } from "react-toastify";
import { generateSalesPdf } from "../Accounts/SaleVoucherPrint";
import "react-toastify/dist/ReactToastify.css";
import config from "../../../config";
import { useNavigate } from "react-router";

const SalesVouchers = () => {
  // ===== States =====
  const [dateMenuAnchor, setDateMenuAnchor] = useState(null);
  const [customDateRange, setCustomDateRange] = useState({
    from: "",
    to: "",
  });
  const [selectingDate, setSelectingDate] = useState(null);
  const dateInputRef = React.useRef(null);
  // ⭐ ADD THESE TWO NEW STATES
  const [showCustomDateInputs, setShowCustomDateInputs] = useState(false);
  const [tempCustomDateRange, setTempCustomDateRange] = useState({
    from: "",
    to: "",
  });

  const [SalesVouchers, setSalesVouchers] = useState([]);
  const [ProjectLists, setProjectLists] = useState([]);
  const [PartyLists, setPartyLists] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [rowErrors, setRowErrors] = useState([]);
  const [rows, setRows] = useState([blankRow()]);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editFormData, setEditFormData] = useState({});
  const [open, setOpen] = useState(false);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [viewData, setViewData] = useState({});

  const [anchorEl, setAnchorEl] = useState(null);
  const [voucherToDelete, setVoucherToDelete] = useState(null);
  const [approveAnchorEl, setApproveAnchorEl] = useState(null);
  const [SalesToApprove, setSalesToApprove] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [expandedSales, setExpandedSales] = useState(null);

  const [showRemarkForIndentId, setShowRemarkForIndentId] = useState(null);
  // NEW STATES FOR MODALS
  const [previewModalOpen, setPreviewModalOpen] = useState(false);
  const [remarkModalOpen, setRemarkModalOpen] = useState(false);
  const [selectedVoucher, setSelectedVoucher] = useState(null);
  const [remarkInput, setRemarkInput] = useState("");
  const [actionType, setActionType] = useState(null);
  const [filters, setFilters] = useState({
    sales_no: "",
    project_name: "",
    party_name: "",
    status: "Pending",
    date_range: "today",
  });
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const navigate = useNavigate();

  // ===== Initial Data Fetch =====
  useEffect(() => {
    fetchAllData();
  }, []);
  useEffect(() => {
    const handler = setTimeout(() => {
      setPage(1);
      fetchVouchers(1, true, filters);
    }, 500);

    return () => clearTimeout(handler);
  }, [filters, customDateRange]);

  const fetchVouchers = async (
    pageNum = 1,
    reset = false,
    filterValues = filters
  ) => {
    const apiFilters = {
      sales_no: filterValues.sales_no,
      project_name: filterValues.project_name,
      party_name: filterValues.party_name,
      status: filterValues.status,

      // ⭐ Date range added:
      date_range: filterValues.date_range,
      from_date: customDateRange.from || "",
      to_date: customDateRange.to || "",
    };

    const data = await GetSalesVoucherList(apiFilters, pageNum);

    if (reset || pageNum === 1) {
      setSalesVouchers(Array.isArray(data) ? data.results : data.results || []);
    } else {
      setSalesVouchers((prev) => [
        ...prev,
        ...(Array.isArray(data) ? data.results : data.results || []),
      ]);
    }

    setHasMore(Array.isArray(data) ? data.next !== null : data.next !== null);
    setPage(pageNum);
  };

  const fetchMoreData = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchVouchers(nextPage);
  };
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };
  const fetchAllData = async () => {
    try {
      const [transporter, Sales] = await Promise.all([
        fetchParty(),
        ApproveSolistapi(),
      ]);

      setPartyLists(
        Array.isArray(transporter) ? transporter : transporter?.results || []
      );
      setProjectLists(Array.isArray(Sales) ? Sales : Sales?.results || []);
    } catch (error) {
      console.error("Data fetch error:", error);
      toast.error("Error fetching initial data");
    }
  };

  const truncateText = (text, limit = 20) => {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

  // ===== Form Utilities =====
  function blankRow() {
    return {
      sales_voucher_no: "",
      sales_number: "",
      project: "",
      division: "",
      party: "",
      invoice_number: "",
      amount: "",
      attachment: "",
      payment_status: "",
      invoice_date: "",
      narration: "",
    };
  }

  const handleRowChange = (index, e) => {
    const { name, value, files } = e.target;
    const updated = [...rows];
    updated[index][name] = name === "attachment" ? files[0] : value;
    setRows(updated);
  };

  const addRow = () => setRows([...rows, blankRow()]);
  const removeRow = (index) => setRows(rows.filter((_, i) => i !== index));

  // ===== Modal Handlers =====
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setRows([blankRow()]);
    setOpen(false);
  };

  // NEW: Handle Checkbox Click to Open Modal
  const handleCheckboxClick = (voucher) => {
    setSelectedVoucher(voucher);
    setPreviewModalOpen(true);
    setRemarkInput("");
    setActionType(null);
  };

  // NEW: Open Remark Dialog Box
  const handleOpenRemarkDialog = (type) => {
    setActionType(type);
    setRemarkModalOpen(true);
    setRemarkInput("");
  };

  // NEW: Handle Approve/Reject from Modal
  const handleApproveReject = async () => {
    if (!selectedVoucher || !actionType) return;

    if (!remarkInput.trim()) {
      toast.error("Please enter a remark!");
      return;
    }

    const approvedById = Number(localStorage.getItem("user_id"));
    if (!approvedById) {
      toast.error("Approver ID not found.");
      return;
    }

    try {
      const updated = await ApproveSalesVoucher(
        selectedVoucher.sales_voucher_no,
        approvedById,
        actionType,
        remarkInput
      );

      setSalesVouchers((prev) =>
        prev.map((item) =>
          item.sales_voucher_no === updated.sales_voucher_no ? updated : item
        )
      );

      toast.success(
        `Sales Voucher ${actionType === "Approved" ? "approved" : "rejected"
        } successfully!`
      );
      setPreviewModalOpen(false);
      setRemarkModalOpen(false);
      setSelectedVoucher(null);
      setRemarkInput("");
      setActionType(null);
    } catch (error) {
      console.error("Approval Error:", error);
      toast.error("Failed to update Sales Voucher status.");
    }
  };

  const handleEditClick = async (voucher) => {
    navigate("/dashboard/sales-voucher-create", {
      state: {
        editMode: true,
        voucherData: voucher,
      },
    });
  };

  const fetchNextSvNo = async () => {
    const data = await GenerateSalesVoucherNo();
    if (data && data.data.sales_voucher_no) {
      setRows((prev) => {
        const updated = [...prev];
        // sirf first row ka voucher no set karo
        if (updated.length > 0) {
          updated[0] = {
            ...updated[0],
            sales_number: data.data.sales_voucher_no,
          };
        }
        return updated;
      });
    }
  };

  // const handleEditClick = async (id) => {
  //   const data = await GetSalesVoucherById(id);
  //   if (data) {
  //     setEditFormData(data);
  //     setEditModalOpen(true);
  //   }
  // };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleView = (voucher) => {
    setViewData(voucher);
    setViewModalOpen(true);
  };
  const userId = Number(localStorage.getItem("user_id"));

  // ===== Submit Handlers =====
  const handleSubmit = async (e) => {
    e.preventDefault();
    const timestamp = Date.now();

    const newData = rows.map((row, i) => ({
      ...row,
      created_by: userId,
      id: timestamp + i,
    }));
    for (const row of newData) {
      try {
        if (!validateForm(row)) return;

        const formData = new FormData();
        formData.append("sales_voucher_no", row.sales_voucher_no || "");
        formData.append("sales_number", row.sales_number || "");
        formData.append("project", row.project || "");
        formData.append("division", row.division || "");
        formData.append("invoice_date", row.invoice_date || "");
        formData.append("invoice_number", row.invoice_number || "");
        formData.append("party", row.party || "");
        formData.append("amount", row.amount || "");
        formData.append("payment_status", row.payment_status || "");
        formData.append("narration", row.narration || "");
        formData.append("created_by", row.created_by);
        // 🔑 File sirf tab append karo jab actual File ho
        if (row.attachment instanceof File) {
          formData.append("attachment", row.attachment);
        }

        await SalesVoucherCreate(formData); // JSON nahi, FormData bhejna hai
      } catch (error) {
        console.error("❌ Failed to submit row:", row, error);
      }
    }

    const updatedList = await GetSalesVoucherList(); // 🔄 Refresh table
    setSalesVouchers(updatedList.results || []);
    toast.success("Voucher(s) added successfully");
    handleClose();
  };

  const handleEditSave = async () => {
    try {
      if (!validateForm(editFormData)) {
        toast.error("Please fill all required fields.");
        return;
      }
      const formData = new FormData();
      formData.append("sales_voucher_no", editFormData.sales_voucher_no || "");
      formData.append("sales_number", editFormData.sales_number || "");
      formData.append("project", editFormData.project || "");
      formData.append("division", editFormData.division || "");
      formData.append("invoice_date", editFormData.invoice_date || "");
      formData.append("invoice_number", editFormData.invoice_number || "");
      formData.append("party", editFormData.party || "");
      formData.append("amount", editFormData.amount || "");
      formData.append("narration", editFormData.narration || "");
      formData.append("payment_status", editFormData.payment_status || "");
      // 🔑 File sirf tabhi append karo jab vo File ho
      if (editFormData.attachment instanceof File) {
        formData.append("attachment", editFormData.attachment);
      }

      const response = await SalesVoucherUpdate(
        editFormData.sales_voucher_no,
        formData // ab JSON nahi, FormData ja raha hai
      );

      setSalesVouchers(response);
      setEditModalOpen(false);
      toast.success("Updated successfully!");
    } catch (error) {
      console.error("Update error:", error.response?.data || error.message);
      toast.error("Update failed.");
    }
  };

  const getDateRangeDisplay = (rangeType) => {
    const now = new Date();
    const formatDate = (date) => {
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };

    switch (rangeType) {
      case "today":
        return formatDate(now);
      case "yesterday":
        const yesterday = new Date(now);
        yesterday.setDate(yesterday.getDate() - 1);
        return formatDate(yesterday);
      case "this_week":
        const weekStart = new Date(now);
        weekStart.setDate(weekStart.getDate() - weekStart.getDay() + 1);
        return `${formatDate(weekStart)} to ${formatDate(now)}`;
      case "previous_week":
        const prevWeekEnd = new Date(now);
        prevWeekEnd.setDate(prevWeekEnd.getDate() - prevWeekEnd.getDay());
        const prevWeekStart = new Date(prevWeekEnd);
        prevWeekStart.setDate(prevWeekStart.getDate() - 6);
        return `${formatDate(prevWeekStart)} to ${formatDate(prevWeekEnd)}`;
      case "this_month":
        const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
        return `${formatDate(monthStart)} to ${formatDate(now)}`;
      case "current_year":
        const yearStart = new Date(now.getFullYear(), 0, 1);
        return `${formatDate(yearStart)} to ${formatDate(now)}`;
      case "financial_year":
        let fyStart;
        if (now.getMonth() >= 3) {
          fyStart = new Date(now.getFullYear(), 3, 1);
        } else {
          fyStart = new Date(now.getFullYear() - 1, 3, 1);
        }
        return `${formatDate(fyStart)} to ${formatDate(now)}`;
      default:
        return "";
    }
  };

  const formatDateDisplay = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };
  const handleDelete = async (voucherId) => {
    try {
      await SalesVoucherDelete(voucherId); // DELETE API
      const updatedList = await GetSalesVoucherList(); // GET latest
      setSalesVouchers(updatedList); // Update table
      toast.success("Deleted successfully!");
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Delete failed.");
    }
  };
  const handleApprove = async (voucher) => {
    const approvedById = Number(localStorage.getItem("user_id"));
    if (!approvedById) {
      toast.error("Approver ID not found.");
      return;
    }

    try {
      const updated = await ApproveSalesVoucher(
        voucher.sales_voucher_no, // <-- important change
        approvedById,
        voucher.status,
        remarkInput
      );

      setSalesVouchers((prev) =>
        prev.map((item) =>
          item.sales_voucher_no === updated.sales_voucher_no ? updated : item
        )
      );

      toast.success("Sales Voucher approved successfully!");
    } catch (error) {
      console.error("Approval Error:", error);
      toast.error("Failed to approve Sales Voucher.");
    }
  };
  const userRole = localStorage.getItem("role"); // "admin" ya "staff"
  const validateForm = (data) => {
    const errors = {};
    const rowErrs = [];

    if (!data.party) errors.party = "Required";
    if (!data.amount) errors.amount = "Required";
    if (!data.payment_status) errors.payment_status = "Required";
    // if (!data.attachment) errors.attachment = "Required";

    setFormErrors(errors);
    setRowErrors(rowErrs);

    return (
      Object.keys(errors).length === 0 &&
      rowErrs.every((e) => Object.keys(e).length === 0)
    );
  };

  useEffect(() => {
    document.body.style.overflow = isMobile ? "auto" : "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMobile]);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // ⭐ ADD THESE TWO FUNCTIONS

  // ✅ Apply Custom Date Range
  const handleApplyCustomDateRange = () => {
    if (tempCustomDateRange.from && tempCustomDateRange.to) {
      setCustomDateRange({ ...tempCustomDateRange });
      setFilters((prev) => ({ ...prev, date_range: "custom" }));
      setDateMenuAnchor(null);
      setShowCustomDateInputs(false);
    } else {
      toast.warning("Please select both From and To dates");
    }
  };

  // ✅ Cancel Custom Date Range
  const handleCancelCustomDateRange = () => {
    setTempCustomDateRange({ from: "", to: "" });
    setShowCustomDateInputs(false);
  };

  const voucherModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "95%", sm: "700px" },
    maxWidth: "650px",
    bgcolor: "white",
    boxShadow: 24,
    p: 0,
    borderRadius: "8px",
    outline: "none",
    maxHeight: "95vh",
    overflow: "auto",
  };

  const remarkModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "90%", sm: "450px" },
    bgcolor: "background.paper",
    borderRadius: 2,
    boxShadow: 24,
    p: 3,
    outline: "none",
  };

  return (
    <>
      <ToastContainer />

      {/* ✅ Responsive Filters */}
      <Box
        display="flex"
        flexWrap={{ xs: "wrap", md: "nowrap" }} // ✅ Mobile mein wrap, Desktop mein nowrap
        alignItems="center"
        sx={{
          mt: -3,
          pt: -3,
          mb: 1,
          width: "100%",
          gap: 2,
        }}
      >
        {/* Status Filter - Radio Buttons */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            flexShrink: 0,
            width: { xs: "100%", md: "auto" }, // ✅ Mobile mein full width
            justifyContent: { xs: "space-around", md: "flex-start" }, // ✅ Mobile mein center
          }}
        >
          <label style={{ fontSize: "12px" }}>
            <input
              type="radio"
              name="status"
              value="Pending"
              checked={filters.status === "Pending"}
              onChange={handleFilterChange}
              style={{ marginRight: "5px", transform: "scale(0.9)" }}
            />
            Pending
          </label>

          <label style={{ fontSize: "12px" }}>
            <input
              type="radio"
              name="status"
              value="Approved"
              checked={filters.status === "Approved"}
              onChange={handleFilterChange}
              style={{ marginRight: "5px", transform: "scale(0.9)" }}
            />
            Approved
          </label>

          <label style={{ fontSize: "12px" }}>
            <input
              type="radio"
              name="status"
              value="Rejected"
              checked={filters.status === "Rejected"}
              onChange={handleFilterChange}
              style={{ marginRight: "5px", transform: "scale(0.9)" }}
            />
            Rejected
          </label>
        </Box>

        <Box
          sx={{
            width: {
              xs: "100%", // = Grid xs={12}
              sm: "50%", // = Grid sm={6}
              md: "16.66%", // = Grid md={2}  (2/12 = 16.66%)
            },
            // padding: "8px", // Grid item ke gap jaisa
          }}
        >
          <TextField
            label="Date Range"
            value={
              filters.date_range === "custom" &&
                customDateRange.from &&
                customDateRange.to
                ? `${formatDateDisplay(
                  customDateRange.from
                )} to ${formatDateDisplay(customDateRange.to)}`
                : filters.date_range === "today"
                  ? "Today"
                  : filters.date_range === "yesterday"
                    ? "Yesterday"
                    : filters.date_range === "this_week"
                      ? "This Week"
                      : filters.date_range === "previous_week"
                        ? "Previous Week"
                        : filters.date_range === "this_month"
                          ? "This Month"
                          : "Select Date Range"
            }
            onClick={(e) => setDateMenuAnchor(e.currentTarget)}
            size="small"
            fullWidth
            InputProps={{
              readOnly: true,
              endAdornment: (
                <IconButton size="small" edge="end">
                  <ArrowDropDownIcon />
                </IconButton>
              ),
            }}
            sx={{
              cursor: "pointer",
              "& .MuiInputBase-input": {
                fontSize: "0.8rem",
                padding: "4px 8px",
              },
              "& .MuiInputBase-root": {
                height: 30,
                borderRadius: 0,
              },
              "& .MuiInputLabel-root": {
                fontSize: "0.7rem",
              },
            }}
          />
        </Box>

        {/* Search Fields Container */}
        <Box
          sx={{
            display: "flex",
            gap: 2,
            flex: 1,
            width: "100%",
            flexDirection: { xs: "column", md: "row" }, // ✅ Mobile mein column, Desktop mein row
          }}
        >
          <TextField
            label="Sales Voucher No"
            name="sales_no"
            size="small"
            value={filters.sales_no}
            onChange={handleFilterChange}
            sx={{
              flex: { xs: "none", md: "1 1 150px" }, // ✅ Desktop mein flex
              width: { xs: "100%", md: "auto" }, // ✅ Mobile mein full width
              "& .MuiInputBase-root": {
                height: 30,
                borderRadius: 0,
              },
              "& .MuiInputLabel-root": {
                fontSize: "0.65rem",
              },
            }}
          />

          <TextField
            label="Project"
            name="project_name"
            size="small"
            value={filters.project_name}
            onChange={handleFilterChange}
            sx={{
              flex: { xs: "none", md: "1 1 150px" },
              width: { xs: "100%", md: "auto" },
              "& .MuiInputBase-root": {
                height: 30,
                borderRadius: 0,
              },
              "& .MuiInputLabel-root": {
                fontSize: "0.65rem",
              },
            }}
          />

          <TextField
            label="Party Name"
            name="party_name"
            size="small"
            value={filters.party_name}
            onChange={handleFilterChange}
            sx={{
              flex: { xs: "none", md: "1 1 150px" },
              width: { xs: "100%", md: "auto" },
              "& .MuiInputBase-root": {
                height: 30,
                borderRadius: 0,
              },
              "& .MuiInputLabel-root": {
                fontSize: "0.65rem",
              },
            }}
          />
        </Box>

        {/* ⭐ REPLACE OLD MENU WITH THIS */}
        <Menu
          anchorEl={dateMenuAnchor}
          open={Boolean(dateMenuAnchor)}
          onClose={() => {
            setDateMenuAnchor(null);
            setShowCustomDateInputs(false);
            setTempCustomDateRange({ from: "", to: "" });
          }}
          PaperProps={{
            sx: { width: 350, maxHeight: 500 },
          }}
        >
          {/* Quick Ranges */}
          {[
            { key: "today", label: "Today" },
            { key: "yesterday", label: "Yesterday" },
            { key: "this_week", label: "This Week" },
            { key: "previous_week", label: "Previous Week" },
            { key: "this_month", label: "This Month" },
          ].map((item) => (
            <MenuItem
              key={item.key}
              onClick={() => {
                setFilters((prev) => ({ ...prev, date_range: item.key }));
                setCustomDateRange({ from: "", to: "" });
                setDateMenuAnchor(null);
                setShowCustomDateInputs(false);
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Typography variant="body2">{item.label}</Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontSize: "0.7rem" }}
                >
                  {getDateRangeDisplay(item.key)}
                </Typography>
              </Box>
            </MenuItem>
          ))}

          <Divider />

          {/* ✅ Custom Date Range - Expandable */}
          <MenuItem
            onClick={() => setShowCustomDateInputs((prev) => !prev)}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              bgcolor: showCustomDateInputs ? "#e3f2fd" : "inherit",
            }}
          >
            <Typography
              variant="body2"
              sx={{ fontWeight: showCustomDateInputs ? 600 : 400 }}
            >
              Custom Date Range
            </Typography>
            {showCustomDateInputs ? <ExpandLess /> : <ExpandMore />}
          </MenuItem>

          <Collapse in={showCustomDateInputs} timeout="auto" unmountOnExit>
            <Box
              sx={{
                px: 2,
                py: 2,
                bgcolor: "#f5f5f5",
                borderTop: "1px solid #e0e0e0",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ mb: 1, display: "block" }}
              >
                Select Date Range
              </Typography>

              {/* From and To Date Inputs Side by Side */}
              <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                <TextField
                  label="From Date"
                  type="date"
                  size="small"
                  value={tempCustomDateRange.from}
                  onChange={(e) =>
                    setTempCustomDateRange((prev) => ({
                      ...prev,
                      from: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    max: tempCustomDateRange.to || undefined,
                  }}
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-root": {
                      height: 40,
                      fontSize: "0.75rem",
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.75rem",
                    },
                  }}
                />

                <TextField
                  label="To Date"
                  type="date"
                  size="small"
                  value={tempCustomDateRange.to}
                  onChange={(e) =>
                    setTempCustomDateRange((prev) => ({
                      ...prev,
                      to: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    min: tempCustomDateRange.from || undefined,
                  }}
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-root": {
                      height: 40,
                      fontSize: "0.75rem",
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.75rem",
                    },
                  }}
                />
              </Box>

              {/* Selected Range Preview */}
              {tempCustomDateRange.from && tempCustomDateRange.to && (
                <Typography
                  variant="caption"
                  sx={{
                    display: "block",
                    mb: 1.5,
                    p: 1,
                    bgcolor: "#e8f5e9",
                    borderRadius: 1,
                    textAlign: "center",
                    color: "#2e7d32",
                    fontWeight: 500,
                  }}
                >
                  📅 {formatDateDisplay(tempCustomDateRange.from)} to{" "}
                  {formatDateDisplay(tempCustomDateRange.to)}
                </Typography>
              )}

              {/* Apply and Cancel Buttons */}
              <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleCancelCustomDateRange}
                  sx={{
                    fontSize: "0.7rem",
                    textTransform: "none",
                    borderRadius: 1,
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleApplyCustomDateRange}
                  disabled={
                    !tempCustomDateRange.from || !tempCustomDateRange.to
                  }
                  sx={{
                    fontSize: "0.7rem",
                    textTransform: "none",
                    borderRadius: 1,
                  }}
                >
                  Apply
                </Button>
              </Box>
            </Box>
          </Collapse>
        </Menu>
      </Box>

      {/* Add Modal - Same as original */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "1400px",
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            maxHeight: "90vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box sx={{ flex: 1, overflowY: "auto", p: 2 }}>
            {rows.map((row, index) => (
              <Box
                key={index}
                sx={{
                  mb: 2,
                  backgroundColor: "#f5f7fa",
                  borderRadius: 2,
                  border: "1px solid #e0e0e0",
                  p: 2,
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      fullWidth
                      label="Voucher No."
                      name="sales_number"
                      value={row.sales_number}
                      size="small"
                      disabled
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      fullWidth
                      label="Invoice No."
                      name="invoice_number"
                      value={row.invoice_number || ""}
                      onChange={(e) => handleRowChange(index, e)}
                      size="small"
                      error={!!formErrors.invoice_number}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      fullWidth
                      label="Invoice Date"
                      name="invoice_date"
                      type="date"
                      value={row.invoice_date || ""}
                      onChange={(e) => handleRowChange(index, e)}
                      size="small"
                      InputLabelProps={{ shrink: true }}
                      error={!!formErrors.invoice_date}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <Autocomplete
                      options={ProjectLists}
                      getOptionLabel={(option) =>
                        option && option.id ? `${option.project_name}` : ""
                      }
                      value={
                        ProjectLists.find((p) => p.id === row.project) || null
                      }
                      onChange={(e, newValue) => {
                        handleRowChange(index, {
                          target: {
                            name: "project",
                            value: newValue ? newValue.id : "",
                          },
                        });

                        if (newValue) {
                          handleRowChange(index, {
                            target: {
                              name: "division",
                              value: newValue.division || "",
                            },
                          });
                          handleRowChange(index, {
                            target: {
                              name: "division_name",
                              value: newValue.division_name || "",
                            },
                          });
                          const totalAmount =
                            newValue.items?.reduce(
                              (sum, i) => sum + Number(i.amount || 0),
                              0
                            ) || 0;
                          handleRowChange(index, {
                            target: {
                              name: "amount",
                              value: totalAmount.toFixed(2),
                            },
                          });
                        } else {
                          ["division", "division_name", "amount"].forEach(
                            (field) =>
                              handleRowChange(index, {
                                target: { name: field, value: "" },
                              })
                          );
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Project"
                          size="small"
                          error={!!formErrors.project}
                          helperText={formErrors.project}
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      fullWidth
                      label="Division"
                      name="division_name"
                      size="small"
                      value={row.division_name || ""}
                      disabled
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <Autocomplete
                      options={PartyLists}
                      getOptionLabel={(option) => option.company_name || ""}
                      value={PartyLists.find((d) => d.id === row.party) || null}
                      onChange={(e, newValue) =>
                        handleRowChange(index, {
                          target: {
                            name: "party",
                            value: newValue ? newValue.id : "",
                          },
                        })
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Party Name"
                          size="small"
                          error={!!formErrors.party}
                          helperText={formErrors.party}
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      fullWidth
                      label="Amount"
                      name="amount"
                      value={row.amount || ""}
                      onChange={(e) => handleRowChange(index, e)}
                      size="small"
                      error={!!formErrors.amount}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      fullWidth
                      label="Payment Status"
                      name="payment_status"
                      value={row.payment_status || ""}
                      onChange={(e) => handleRowChange(index, e)}
                      select
                      size="small"
                      error={!!formErrors.payment_status}
                    >
                      <MenuItem value="Paid">Paid</MenuItem>
                      <MenuItem value="Unpaid">Unpaid</MenuItem>
                    </TextField>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      fullWidth
                      label="Narration"
                      name="narration"
                      value={row.narration || ""}
                      onChange={(e) => handleRowChange(index, e)}
                      size="small"
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      fullWidth
                      type="file"
                      name="attachment"
                      id={`attachment-${index}`}
                      onChange={(e) => handleRowChange(index, e)}
                      label="Attachment"
                      size="small"
                      InputLabelProps={{ shrink: true }}
                      error={!!formErrors.attachment}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    {rows.length > 1 && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          height: "100%",
                        }}
                      >
                        <Button
                          variant="outlined"
                          color="error"
                          onClick={() => removeRow(index)}
                          size="small"
                          startIcon={<Close fontSize="small" />}
                          sx={{ textTransform: "none", fontWeight: 500 }}
                        >
                          Remove
                        </Button>
                      </Box>
                    )}
                  </Grid>
                </Grid>
              </Box>
            ))}
          </Box>

          <Box
            sx={{
              borderTop: "1px solid #ddd",
              p: 2,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              backgroundColor: "#fafafa",
              gap: 1,
            }}
          >
            <Box sx={{ display: "flex", gap: 1 }}>
              <Button
                variant="outlined"
                onClick={handleSubmit}
                size="small"
                sx={{ px: 2, fontWeight: 500 }}
              >
                Submit
              </Button>
              <Button
                variant="contained"
                onClick={handleClose}
                size="small"
                sx={{ px: 2 }}
              >
                Close
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* Table / Mobile List */}
      <InfiniteScroll
        dataLength={SalesVouchers.length}
        next={fetchMoreData}
        hasMore={hasMore}
        loader={<h4>Loading...</h4>}
        endMessage={<p style={{ textAlign: "center" }}>No more vouchers!</p>}
      >
        {isMobile ? (
          /* 📱 MOBILE VIEW ONLY */
          <Box sx={{ bgcolor: "background.paper" }}>
            {SalesVouchers.map((voucher, index) => (
              <Box key={index}>
                <Box
                  onClick={() =>
                    setExpandedSales(
                      expandedSales === voucher.sales_voucher_no
                        ? null
                        : voucher.sales_voucher_no
                    )
                  }
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 1.5,
                    cursor: "pointer",
                    bgcolor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                    "&:active": { bgcolor: "#e3f2fd" },
                    borderLeft: `4px solid ${voucher.status === "Approved"
                        ? "#4caf50"
                        : voucher.status === "Rejected"
                          ? "#f44336"
                          : "#ff9800"
                      }`,
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mb: 0.5,
                      }}
                    >
                      <Typography
                        sx={{ fontSize: "0.7rem", color: "#666", minWidth: 25 }}
                      >
                        #{index + 1}
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontSize: "0.85rem",
                          flex: 1,
                        }}
                      >
                        {voucher.sales_number}
                      </Typography>
                      {/* <Chip
                        label={
                          voucher.status === "Approved" ? "✓" : voucher.status === "Rejected" ? "✗" : "⏱"
                        }
                        color={
                          voucher.status === "Approved"
                            ? "success"
                            : voucher.status === "Rejected"
                              ? "error"
                              : "warning"
                        }
                        size="small"
                        sx={{ height: 20, minWidth: 30, fontSize: "0.7rem", "& .MuiChip-label": { px: 0.5 } }}
                      /> */}
                    </Box>
                    <Typography
                      sx={{
                        fontSize: "0.75rem",
                        color: "#666",
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <span style={{ fontWeight: 500 }}>
                        {voucher.project_name?.substring(0, 25) || "N/A"}
                      </span>
                      <span style={{ color: "#999" }}>•</span>
                      <span style={{ fontSize: "0.7rem" }}>
                        {formatDate(voucher.created_at)}
                      </span>
                    </Typography>
                  </Box>
                  <IconButton size="small" sx={{ ml: 1 }}>
                    {expandedSales === voucher.sales_voucher_no ? (
                      <ExpandLess fontSize="small" />
                    ) : (
                      <ExpandMore fontSize="small" />
                    )}
                  </IconButton>
                </Box>

                <Collapse
                  in={expandedSales === voucher.sales_voucher_no}
                  timeout="auto"
                  unmountOnExit
                >
                  <Box
                    sx={{
                      px: 1.5,
                      py: 1,
                      bgcolor: index % 2 === 0 ? "#f8f9fa" : "#fafafa",
                      borderLeft: `4px solid ${voucher.status === "Approved"
                          ? "#4caf50"
                          : voucher.status === "Rejected"
                            ? "#f44336"
                            : "#ff9800"
                        }`,
                    }}
                  >
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: 0.8,
                        mb: 1,
                      }}
                    >
                      <Box sx={{ gridColumn: "1 / -1" }}>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          PROJECT
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.75rem",
                            fontWeight: 500,
                            color: "#333",
                          }}
                        >
                          {voucher.project_name || "N/A"}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          TOTAL AMT
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 600,
                            color: "#1976d2",
                          }}
                        >
                          ₹{" "}
                          {Number(voucher.amount || 0).toLocaleString("en-IN")}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          REC AMT
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 600,
                            color: "#4caf50",
                          }}
                        >
                          ₹{" "}
                          {Number(voucher.receipt_amount || 0).toLocaleString(
                            "en-IN"
                          )}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          BAL AMT
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 600,
                            color: "#f44336",
                          }}
                        >
                          ₹{" "}
                          {Number(voucher.balance_amount || 0).toLocaleString(
                            "en-IN"
                          )}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          DIVISION
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {voucher.division_name || "-"}
                        </Typography>
                      </Box>

                      <Box sx={{ gridColumn: "1 / -1" }}>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          DEBTOR
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {voucher.company_name || "-"}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          INVOICE NO
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {voucher.invoice_number || "-"}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          INVOICE DATE
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {formatDate(voucher.invoice_date)}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                            mb: 0.3,
                          }}
                        >
                          PAYMENT STATUS
                        </Typography>
                        <Chip
                          label={
                            voucher.payment_status === "Paid"
                              ? "Paid"
                              : voucher.payment_status === "Unpaid"
                                ? "Unpaid"
                                : "Partial"
                          }
                          color={
                            voucher.payment_status === "Paid"
                              ? "success"
                              : voucher.payment_status === "Unpaid"
                                ? "error"
                                : "warning"
                          }
                          variant="outlined"
                          size="small"
                          sx={{
                            // fontSize: "0.2rem", // 👈 font chhota hoga
                            height: "10px",
                            transform: "scale(0.8)",
                            "& .MuiChip-label": {
                              padding: "0 6px",
                            },
                          }}
                        />
                      </Box>

                      {voucher.created_by_name && (
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            CREATED BY
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 500,
                              color: "#555",
                            }}
                          >
                            {voucher.created_by_name}
                          </Typography>
                        </Box>
                      )}

                      {voucher.approved_name && (
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            APPROVED BY
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 500,
                              color: "#555",
                            }}
                          >
                            {voucher.approved_name}
                          </Typography>
                        </Box>
                      )}
                    </Box>

                    {voucher.remarks && (
                      <Box sx={{ mb: 0.8 }}>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                            mb: 0.3,
                          }}
                        >
                          REMARKS
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.7rem",
                            color: "#555",
                            fontStyle: "italic",
                            lineHeight: 1.3,
                          }}
                        >
                          {voucher.remarks}
                        </Typography>
                      </Box>
                    )}

                    <Divider sx={{ my: 1, borderColor: "#e0e0e0" }} />

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      {userRole != "Staff" && (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            bgcolor:
                              voucher.status === "Approved"
                                ? "#e8f5e9"
                                : voucher.status === "Rejected"
                                  ? "#ffebee"
                                  : "#fff3e0",
                            px: 1,
                            py: 0.5,
                            borderRadius: "6px",
                            border: `1px solid ${voucher.status === "Approved"
                                ? "#4caf50"
                                : voucher.status === "Rejected"
                                  ? "#f44336"
                                  : "#ff9800"
                              }`,
                          }}
                        >
                          <Checkbox
                            checked={
                              voucher.status === "Approved" ||
                              voucher.status === "Rejected"
                            }
                            onChange={(e) => {
                              e.stopPropagation();
                              setApproveAnchorEl(e.currentTarget);
                              setSalesToApprove(voucher);
                            }}
                            sx={{
                              padding: 0,
                              transform: "scale(0.6)",
                              color:
                                voucher.status === "Approved"
                                  ? "#4caf50"
                                  : voucher.status === "Rejected"
                                    ? "#f44336"
                                    : "#ff9800",
                              "&.Mui-checked": {
                                color:
                                  voucher.status === "Approved"
                                    ? "#4caf50"
                                    : "#f44336",
                              },
                            }}
                          />
                          <Typography
                            sx={{
                              fontSize: "0.7rem",
                              fontWeight: 600,
                              color:
                                voucher.status === "Approved"
                                  ? "#2e7d32"
                                  : voucher.status === "Rejected"
                                    ? "#c62828"
                                    : "#f57c00",
                            }}
                          >
                            {voucher.status === "Approved"
                              ? "Approved"
                              : voucher.status === "Rejected"
                                ? "Rejected"
                                : "Approve"}
                          </Typography>
                        </Box>
                      )}

                      <Box sx={{ display: "flex", gap: 0.6 }}>
                        {typeof voucher.attachment === "string" && (
                          <a
                            href={`${voucher.attachment}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <IconButton
                              size="small"
                              sx={{
                                bgcolor: "#e1f5fe",
                                borderRadius: "6px",
                                width: 32,
                                height: 32,
                                "&:hover": {
                                  bgcolor: "#b3e5fc",
                                  transform: "scale(1.05)",
                                },
                                transition: "all 0.2s",
                              }}
                            >
                              <Visibility
                                sx={{ fontSize: "1rem", color: "#0288d1" }}
                              />
                            </IconButton>
                          </a>
                        )}

                        {voucher.attachment instanceof File && (
                          <a
                            href={URL.createObjectURL(voucher.attachment)}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <IconButton
                              size="small"
                              sx={{
                                bgcolor: "#e1f5fe",
                                borderRadius: "6px",
                                width: 32,
                                height: 32,
                                "&:hover": {
                                  bgcolor: "#b3e5fc",
                                  transform: "scale(1.05)",
                                },
                                transition: "all 0.2s",
                              }}
                            >
                              <Visibility
                                sx={{ fontSize: "1rem", color: "#0288d1" }}
                              />
                            </IconButton>
                          </a>
                        )}

                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            generateSalesPdf(voucher);
                          }}
                          sx={{
                            bgcolor: "#fff3e0",
                            borderRadius: "6px",
                            width: 32,
                            height: 32,
                            "&:hover": {
                              bgcolor: "#ffe0b2",
                              transform: "scale(1.05)",
                            },
                            transition: "all 0.2s",
                          }}
                        >
                          <Print
                            transform="scale(0.6)"
                            sx={{ color: "#f57c00" }}
                          />
                        </IconButton>
                      </Box>
                    </Box>
                  </Box>
                </Collapse>
                <Divider />
              </Box>
            ))}

            {/* ✅ Conditional Total Summary - Only if data exists */}
            {/* {SalesVouchers.length > 0 && (
              <Box sx={{ bgcolor: "#E3F2FD", p: 1.5, borderTop: "2px solid #1976d2" }}>
                <Typography sx={{ fontSize: "0.75rem", fontWeight: "bold", mb: 1, color: "#1976d2" }}>
                  TOTALS
                </Typography>
                <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 1 }}>
                  <Box>
                    <Typography sx={{ fontSize: "0.6rem", color: "#666" }}>Total Amt</Typography>
                    <Typography sx={{ fontSize: "0.75rem", fontWeight: "bold", color: "#1976d2" }}>
                      ₹{" "}
                      {SalesVouchers.reduce((sum, v) => sum + parseFloat(v.amount || 0), 0).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: "0.6rem", color: "#666" }}>Rec Amt</Typography>
                    <Typography sx={{ fontSize: "0.75rem", fontWeight: "bold", color: "#4caf50" }}>
                      ₹{" "}
                      {SalesVouchers.reduce((sum, v) => sum + parseFloat(v.receipt_amount || 0), 0).toLocaleString(
                        "en-IN",
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                      )}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: "0.6rem", color: "#666" }}>Bal Amt</Typography>
                    <Typography sx={{ fontSize: "0.75rem", fontWeight: "bold", color: "#f44336" }}>
                      ₹{" "}
                      {SalesVouchers.reduce((sum, v) => sum + parseFloat(v.balance_amount || 0), 0).toLocaleString(
                        "en-IN",
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                      )}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            )} */}
          </Box>
        ) : (
          /* 💻 DESKTOP VIEW - ORIGINAL TABLE */
          <TableContainer
            component={Paper}
            sx={{ maxHeight: "88vh", overflow: "auto" }}
          >
            <Table
              stickyHeader
              size="small"
              sx={{
                minWidth: 1600,
                "& td, & th": {
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  backgroundColor: "#f5f5f5",
                  borderBottom: "1px solid #ccc",
                },
              }}
            >
              <TableHead>
                <TableRow
                  sx={{
                    backgroundColor: "#f5f5f5",
                    "& th": {
                      fontWeight: "bold",
                      color: "#333",
                      borderBottom: "1px solid #999",
                      whiteSpace: "nowrap",
                      fontsize: "0.75rem",
                    },
                  }}
                >
                  {userRole != "Staff" && (
                    <TableCell
                      sx={{
                        position: "sticky",
                        left: 0,
                        backgroundColor: "#fafafa",
                        zIndex: 3,
                      }}
                    >
                      Approve
                    </TableCell>
                  )}
                  <TableCell
                    sx={{
                      position: "sticky",
                      left: userRole != "Staff" ? 80 : 0,
                      backgroundColor: "#f5f5f5",
                      zIndex: 3,
                    }}
                  >
                    S.No.
                  </TableCell>

                  <TableCell>Sales Voucher No</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Total Amt</TableCell>
                  <TableCell>Rec Amt</TableCell>
                  <TableCell>Bal Amt</TableCell>
                  <TableCell>Project</TableCell>
                  <TableCell>Division</TableCell>
                  <TableCell>Debtor</TableCell>
                  <TableCell>Payment Status</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Invoice No</TableCell>
                  <TableCell>Invoice Date</TableCell>
                  <TableCell>Created By</TableCell>
                  <TableCell>Approved By</TableCell>
                  <TableCell>Remarks</TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      position: "sticky",
                      right: 0,
                      backgroundColor: "#f5f5f5",
                      zIndex: 3,
                      minWidth: 180,
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {SalesVouchers.map((voucher, index) => (
                  <TableRow
                    hover
                    key={index}
                    sx={{
                      position: "sticky",
                      right: 0,
                      backgroundColor: "#fff",
                      zIndex: 1,
                      backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                      "&:hover": {
                        backgroundColor: "#e3f2fd",
                        "& td": {
                          backgroundColor: "#e3f2fd !important",
                        },
                      },
                      "& td": {
                        paddingRight: "13px !important",
                        paddingLeft: "13px !important",
                        padding: "0px",
                        fontSize: { xs: "0.65rem", sm: "0.75rem" },
                        whiteSpace: "nowrap",
                        color: (theme) =>
                          theme.palette.mode === "dark" ? "white" : "inherit",
                        backgroundColor: (theme) =>
                          theme.palette.mode === "dark" ? "black" : "inherit",
                      },
                    }}
                  >
                    {userRole != "Staff" && (
                      <TableCell
                        sx={{
                          position: "sticky",
                          left: 0,
                          backgroundColor: "#fafafa",
                          zIndex: 3,
                        }}
                      >
                        <Checkbox
                          checked={
                            voucher.status === "Approved" ||
                            voucher.status === "Rejected"
                          }
                          onChange={(e) => {
                            handleCheckboxClick(voucher);
                            setSalesToApprove(voucher);
                          }}
                          sx={{
                            padding: 0,
                            paddingLeft: 1,
                            paddingRight: 1,
                            transform: "scale(0.8)",
                            color:
                              voucher.status === "Approved"
                                ? "green"
                                : voucher.status === "Rejected"
                                  ? "red"
                                  : "grey",
                            "&.Mui-checked": {
                              color:
                                voucher.status === "Approved" ? "green" : "red",
                            },
                          }}
                        />
                      </TableCell>
                    )}
                    <TableCell
                      sx={{
                        position: "sticky",
                        left: userRole != "Staff" ? 80 : 0,
                        backgroundColor: "#f5f5f5",
                        zIndex: 3,
                      }}
                    >
                      {index + 1}
                    </TableCell>

                    <TableCell>{voucher.sales_number}</TableCell>
                    <TableCell align="center">
                      <Chip
                        label={
                          voucher.status === "Approved"
                            ? "Approved"
                            : voucher.status === "Rejected"
                              ? "Rejected"
                              : "Pending"
                        }
                        color={
                          voucher.status === "Approved"
                            ? "success"
                            : voucher.status === "Rejected"
                              ? "error"
                              : "warning"
                        }
                        variant="outlined"
                        sx={{
                          // fontSize: "0.2rem", // 👈 font chhota hoga
                          height: "10px",
                          transform: "scale(0.8)",
                          "& .MuiChip-label": {
                            padding: "0 6px",
                          },
                        }}
                      />
                    </TableCell>
                    <TableCell>{voucher.amount}</TableCell>
                    <TableCell>{voucher.receipt_amount}</TableCell>
                    <TableCell>{voucher.balance_amount}</TableCell>
                    <TableCell>{voucher.project_name}</TableCell>
                    <TableCell>{voucher.division_name}</TableCell>
                    <TableCell>
                      <Tooltip title={voucher.company_name} arrow>
                        <span>{truncateText(voucher.company_name, 20)}</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={
                          voucher.payment_status === "Paid"
                            ? "Paid"
                            : voucher.payment_status === "Unpaid"
                              ? "Unpaid"
                              : "Partial"
                        }
                        color={
                          voucher.payment_status === "Paid"
                            ? "success"
                            : voucher.payment_status === "Unpaid"
                              ? "error"
                              : "warning"
                        }
                        variant="outlined"
                        size="small"
                        sx={{
                          // fontSize: "0.2rem", // 👈 font chhota hoga
                          height: "10px",
                          transform: "scale(0.8)",
                          "& .MuiChip-label": {
                            padding: "0 6px",
                          },
                        }}
                      />
                    </TableCell>

                    <TableCell>{formatDate(voucher.created_at)}</TableCell>
                    <TableCell>{voucher.invoice_number}</TableCell>
                    <TableCell>{formatDate(voucher.invoice_date)}</TableCell>

                    <TableCell>{voucher.created_by_name}</TableCell>
                    <TableCell>{voucher.approved_name}</TableCell>
                    <TableCell>
                      <Tooltip title={voucher.remarks || ""} arrow>
                        <span>{truncateText(voucher.remarks || "", 20)}</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell
                      sx={{
                        position: "sticky",
                        right: 0,
                        backgroundColor: "#f5f5f5",
                        zIndex: 3,
                        minWidth: 180,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: 0.5,
                        }}
                      >
                        <IconButton
                          sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                          color="warning"
                          size="small"
                          onClick={() => generateSalesPdf(voucher)}
                        >
                          <Print fontSize="small" />
                        </IconButton>
                        <span
                          style={{
                            display: "inline-block",
                            width: 36,
                            textAlign: "center",
                          }}
                        >
                          {typeof voucher.attachment === "string" ? (
                            <a
                              href={`${voucher.attachment}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <IconButton
                                sx={{
                                  padding: 0,
                                  paddingLeft: 1,
                                  paddingRight: 1,
                                }}
                                color="info"
                                size="small"
                              >
                                <Visibility fontSize="small" />
                              </IconButton>
                            </a>
                          ) : voucher.attachment instanceof File ? (
                            <a
                              href={URL.createObjectURL(voucher.attachment)}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <IconButton
                                sx={{
                                  padding: 0,
                                  paddingLeft: 1,
                                  paddingRight: 1,
                                }}
                                color="info"
                                size="small"
                              >
                                <Visibility fontSize="small" />
                              </IconButton>
                            </a>
                          ) : (
                            <span
                              style={{ display: "inline-block", width: 24 }}
                            />
                          )}
                        </span>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </InfiniteScroll>

      {/* Popovers - Same */}
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
          setVoucherToDelete(null);
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Box sx={{ p: 2 }}>
          <Typography variant="body2">Are you sure?</Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
            <Button
              color="error"
              size="small"
              onClick={async () => {
                await handleDelete(voucherToDelete);
                setAnchorEl(null);
                setVoucherToDelete(null);
              }}
            >
              Yes
            </Button>
            <Button
              size="small"
              onClick={() => {
                setAnchorEl(null);
                setVoucherToDelete(null);
              }}
            >
              No
            </Button>
          </Box>
        </Box>
      </Popover>

      <Modal
        open={previewModalOpen}
        onClose={() => setPreviewModalOpen(false)}
        aria-labelledby="voucher-preview-modal"
        sx={{
          // Mobile center fix
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: { xs: 2, md: 0 },
        }}
      >
        <Box
          sx={{
            position: { xs: "relative", md: "absolute" },
            top: { xs: "auto", md: "50%" },
            left: { xs: "auto", md: "50%" },
            transform: { xs: "none", md: "translate(-50%, -50%)" },

            // Responsive width - EQUAL LEFT RIGHT SPACE
            width: {
              xs: "calc(100% - 32px)",
              sm: "90vw",
              md: 800,
            },
            maxWidth: {
              xs: "100%",
              md: 800,
            },

            // Height & scroll
            maxHeight: {
              xs: "85vh",
              md: "90vh",
            },
            overflowY: "auto",

            // Styling
            bgcolor: "background.paper",
            borderRadius: { xs: "12px", md: "8px" },
            boxShadow: 24,
            margin: 0,
            outline: "none",
          }}
        >
          {/* SALES VOUCHER Header */}
          <Typography
            variant="h5"
            sx={{
              fontWeight: "bold",
              letterSpacing: 1,
              textAlign: "center",
              p: { xs: 1.5, md: 2 },
              fontSize: { xs: "1.1rem", md: "1.5rem" },
              bgcolor: "#f5f5f5",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            SALES VOUCHER
          </Typography>

          {/* Voucher Content Container */}
          <Box
            sx={{
              p: { xs: 1.5, sm: 2, md: 3 },
              background: "linear-gradient(to bottom, #ffffff, #f9f9f9)",
              display: "flex",
              flexDirection: "column",
              gap: { xs: 1.5, md: 2 },
            }}
          >
            {/* ===== MOBILE VIEW ===== */}
            <Box sx={{ display: { xs: "block", md: "none" } }}>

              {/* Voucher Details - Mobile Card */}
              <Box
                sx={{
                  border: "1px solid #d0d0d0",
                  borderRadius: "8px",
                  overflow: "hidden",
                  mb: 1.5,
                  bgcolor: "#fff",
                }}
              >
                {/* Row 1 */}
                <Box sx={{ display: "flex", borderBottom: "1px solid #e0e0e0" }}>
                  <Box sx={{ flex: 1, p: 1.5, borderRight: "1px solid #e0e0e0" }}>
                    <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                      Voucher No.
                    </Typography>
                    <Typography variant="body2" fontWeight={600} color="primary" sx={{ fontSize: "0.8rem" }}>
                      {selectedVoucher?.sales_number || "N/A"}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1, p: 1.5 }}>
                    <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                      Invoice Date
                    </Typography>
                    <Typography variant="body2" fontWeight={600} color="primary" sx={{ fontSize: "0.8rem" }}>
                      {formatDate(selectedVoucher?.invoice_date)}
                    </Typography>
                  </Box>
                </Box>

                {/* Row 2 */}
                <Box sx={{ display: "flex", borderBottom: "1px solid #e0e0e0" }}>
                  <Box sx={{ flex: 1, p: 1.5, borderRight: "1px solid #e0e0e0" }}>
                    <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                      Invoice No
                    </Typography>
                    <Typography variant="body2" fontWeight={600} sx={{ fontSize: "0.8rem" }}>
                      {selectedVoucher?.invoice_number || "N/A"}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1, p: 1.5 }}>
                    <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                      Division
                    </Typography>
                    <Typography variant="body2" fontWeight={600} sx={{ fontSize: "0.8rem" }}>
                      {selectedVoucher?.division_name || "N/A"}
                    </Typography>
                  </Box>
                </Box>

                {/* Row 3 */}
                <Box sx={{ p: 1.5, bgcolor: "#f8f9fa" }}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                    Project Name
                  </Typography>
                  <Typography variant="body2" fontWeight={600} sx={{ fontSize: "0.8rem", wordBreak: "break-word" }}>
                    {selectedVoucher?.project_name || "N/A"}
                  </Typography>
                </Box>
              </Box>

              {/* Amount Section - Mobile */}
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  gap: 1,
                  mb: 1.5,
                }}
              >
                <Box sx={{ bgcolor: "#f8f9fa", p: 1.5, borderRadius: "8px", textAlign: "center", border: "1px solid #e0e0e0" }}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.6rem" }}>
                    Basic Value
                  </Typography>
                  <Typography variant="body2" fontWeight={700} color="primary" sx={{ fontSize: "0.75rem" }}>
                    ₹{Number(selectedVoucher?.amount || 0).toLocaleString("en-IN")}
                  </Typography>
                </Box>
                <Box sx={{ bgcolor: "#fff3e0", p: 1.5, borderRadius: "8px", textAlign: "center", border: "1px solid #ffe0b2" }}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.6rem" }}>
                    GST Amount
                  </Typography>
                  <Typography variant="body2" fontWeight={700} color="error" sx={{ fontSize: "0.75rem" }}>
                    ₹{Number(selectedVoucher?.gst_amount || 0).toLocaleString("en-IN")}
                  </Typography>
                </Box>
                <Box sx={{ bgcolor: "#e8f5e9", p: 1.5, borderRadius: "8px", textAlign: "center", border: "1px solid #c8e6c9" }}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.6rem" }}>
                    Grand Total
                  </Typography>
                  <Typography variant="body2" fontWeight={700} color="success.main" sx={{ fontSize: "0.75rem" }}>
                    ₹{Number(selectedVoucher?.total_amount || 0).toLocaleString("en-IN")}
                  </Typography>
                </Box>
              </Box>

              {/* Payment Status & Narration - Mobile */}
              <Box sx={{ display: "flex", gap: 1, mb: 1.5 }}>
                <Box sx={{ flex: 1, bgcolor: "#f8f9fa", p: 1.5, borderRadius: "8px", border: "1px solid #e0e0e0" }}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem", mb: 0.5, display: "block" }}>
                    Payment Status
                  </Typography>
                  <Chip
                    label={selectedVoucher?.payment_status || "Unpaid"}
                    color={
                      selectedVoucher?.payment_status === "Paid" ? "success" :
                        selectedVoucher?.payment_status === "Partial" ? "warning" :
                          selectedVoucher?.payment_status === "Overpaid" ? "info" : "error"
                    }
                    size="small"
                    sx={{ fontSize: "0.65rem", height: "20px" }}
                  />
                </Box>
                <Box sx={{ flex: 2, bgcolor: "#f8f9fa", p: 1.5, borderRadius: "8px", border: "1px solid #e0e0e0" }}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                    Narration
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: "0.75rem", wordBreak: "break-word" }}>
                    {selectedVoucher?.remarks || "No remarks"}
                  </Typography>
                </Box>
              </Box>

              {/* DEBTOR DETAILS Header - Mobile */}
              <Box
                sx={{
                  bgcolor: "#e3f2fd",
                  color: "#1a237e",
                  textAlign: "center",
                  py: 1,
                  borderRadius: "8px",
                  mb: 1.5,
                }}
              >
                <Typography variant="subtitle2" fontWeight="bold" sx={{ fontSize: "0.8rem" }}>
                  DEBTOR DETAILS
                </Typography>
              </Box>

              {/* Debtor Details - Mobile Card */}
              <Box
                sx={{
                  border: "1px solid #d0d0d0",
                  borderRadius: "8px",
                  overflow: "hidden",
                  bgcolor: "#fff",
                }}
              >
                {/* Debtor Name */}
                <Box sx={{ p: 1.5, borderBottom: "1px solid #e0e0e0", bgcolor: "#f8f9fa" }}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                    Debtor
                  </Typography>
                  <Typography variant="body2" fontWeight={600} sx={{ fontSize: "0.8rem" }}>
                    {selectedVoucher?.debtor?.company_name || "N/A"}
                  </Typography>
                </Box>

                {/* GST & PAN */}
                <Box sx={{ display: "flex", borderBottom: "1px solid #e0e0e0" }}>
                  <Box sx={{ flex: 1, p: 1.5, borderRight: "1px solid #e0e0e0" }}>
                    <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                      GST No
                    </Typography>
                    <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                      {selectedVoucher?.debtor?.gst || "N/A"}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1, p: 1.5 }}>
                    <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                      PAN No
                    </Typography>
                    <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                      {selectedVoucher?.debtor?.pan || "N/A"}
                    </Typography>
                  </Box>
                </Box>

                {/* Contact & Phone */}
                <Box sx={{ display: "flex", borderBottom: "1px solid #e0e0e0" }}>
                  <Box sx={{ flex: 1, p: 1.5, borderRight: "1px solid #e0e0e0" }}>
                    <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                      Contact Name
                    </Typography>
                    <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                      {selectedVoucher?.debtor?.name || "N/A"}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1, p: 1.5 }}>
                    <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                      Phone No
                    </Typography>
                    <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                      {selectedVoucher?.debtor?.contact || "N/A"}
                    </Typography>
                  </Box>
                </Box>

                {/* Email */}
                <Box sx={{ p: 1.5, borderBottom: "1px solid #e0e0e0" }}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                    Email
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: "0.75rem", wordBreak: "break-all" }}>
                    {selectedVoucher?.debtor?.email || "N/A"}
                  </Typography>
                </Box>

                {/* Address */}
                <Box sx={{ p: 1.5, bgcolor: "#f8f9fa" }}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                    Address
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: "0.75rem", wordBreak: "break-word" }}>
                    {selectedVoucher?.debtor?.address || "N/A"}
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* ===== DESKTOP VIEW - UNCHANGED ===== */}
            <Box sx={{ display: { xs: "none", md: "block" } }}>
              {/* Two-column layout for voucher details */}
              <Box
                sx={{
                  border: "1px solid #d0d0d0",
                  borderRadius: "4px",
                  overflow: "hidden",
                }}
              >
                {/* First Row */}
                <Box
                  sx={{
                    display: "flex",
                    borderBottom: "1px solid #d0d0d0",
                    backgroundColor: "#f8f9fa",
                  }}
                >
                  <Box sx={{ width: "50%", borderRight: "1px solid #d0d0d0", p: 1 }}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: "bold", fontSize: "0.7rem", color: "#333", minWidth: "90px" }}
                      >
                        Voucher No.
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ fontSize: "0.75rem", fontWeight: 500, color: "#1a237e" }}
                      >
                        : {selectedVoucher?.sales_number || "N/A"}
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{ width: "50%", p: 1 }}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: "bold", fontSize: "0.7rem", color: "#333", minWidth: "90px" }}
                      >
                        Invoice Date
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ fontSize: "0.75rem", fontWeight: 500, color: "#1a237e" }}
                      >
                        : {formatDate(selectedVoucher?.invoice_date)}
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {/* Second Row */}
                <Box sx={{ display: "flex", borderBottom: "1px solid #d0d0d0" }}>
                  <Box sx={{ width: "50%", borderRight: "1px solid #d0d0d0", p: 1 }}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: "bold", fontSize: "0.7rem", color: "#333", minWidth: "90px" }}
                      >
                        Invoice No
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ fontSize: "0.75rem", fontWeight: 500, color: "#1a237e" }}
                      >
                        : {selectedVoucher?.invoice_number || "N/A"}
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{ width: "50%", p: 1 }}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: "bold", fontSize: "0.7rem", color: "#333", minWidth: "90px" }}
                      >
                        Division
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ fontSize: "0.75rem", fontWeight: 500, color: "#1a237e" }}
                      >
                        : {selectedVoucher?.division_name || "N/A"}
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {/* Third Row */}
                <Box sx={{ p: 1, backgroundColor: "#f8f9fa" }}>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: "bold", fontSize: "0.7rem", color: "#333", minWidth: "90px" }}
                    >
                      Project Name
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "0.75rem", fontWeight: 500, color: "#1a237e" }}
                    >
                      : {selectedVoucher?.project_name || "N/A"}
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {/* Amount Section */}
              <Box
                sx={{
                  border: "1px solid #d0d0d0",
                  borderRadius: "4px",
                  overflow: "hidden",
                  mt: 2,
                }}
              >
                <Box sx={{ display: "flex", backgroundColor: "#f8f9fa" }}>
                  <Box sx={{ width: "33.33%", p: 1, borderRight: "1px solid #d0d0d0", textAlign: "center" }}>
                    <Typography variant="body2" sx={{ fontWeight: "bold", fontSize: "0.7rem", color: "#333", mb: 0.3 }}>
                      Basic Value
                    </Typography>
                    <Typography variant="body2" sx={{ fontSize: "0.8rem", fontWeight: 600, color: "#1a237e" }}>
                      {Number(selectedVoucher?.amount || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                    </Typography>
                  </Box>
                  <Box sx={{ width: "33.33%", p: 1, borderRight: "1px solid #d0d0d0", textAlign: "center" }}>
                    <Typography variant="body2" sx={{ fontWeight: "bold", fontSize: "0.7rem", color: "#333", mb: 0.3 }}>
                      GST Amount
                    </Typography>
                    <Typography variant="body2" sx={{ fontSize: "0.8rem", fontWeight: 600, color: "#d32f2f" }}>
                      {Number(selectedVoucher?.gst_amount || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                    </Typography>
                  </Box>
                  <Box sx={{ width: "33.33%", p: 1, textAlign: "center" }}>
                    <Typography variant="body2" sx={{ fontWeight: "bold", fontSize: "0.7rem", color: "#333", mb: 0.3 }}>
                      Grand Total
                    </Typography>
                    <Typography variant="body2" sx={{ fontSize: "0.8rem", fontWeight: 600, color: "#2e7d32" }}>
                      {Number(selectedVoucher?.total_amount || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {/* Payment Status and Narration */}
              <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
                <Box sx={{ flex: 1 }}>
                  <Box sx={{ border: "1px solid #d0d0d0", borderRadius: "4px", p: 1, backgroundColor: "#f8f9fa", height: "100%" }}>
                    <Typography variant="body2" sx={{ fontWeight: "bold", fontSize: "0.7rem", color: "#333", mb: 0.5 }}>
                      Payment Status
                    </Typography>
                    <Chip
                      label={
                        selectedVoucher?.payment_status === "Overpaid" ? "Overpaid" :
                          selectedVoucher?.payment_status === "Paid" ? "Paid" :
                            selectedVoucher?.payment_status === "Partial" ? "Partial" : "Unpaid"
                      }
                      color={
                        selectedVoucher?.payment_status === "Overpaid" ? "info" :
                          selectedVoucher?.payment_status === "Paid" ? "success" :
                            selectedVoucher?.payment_status === "Partial" ? "warning" : "error"
                      }
                      size="small"
                      sx={{ fontSize: "0.7rem", fontWeight: "bold", height: "20px" }}
                    />
                  </Box>
                </Box>
                <Box sx={{ flex: 2 }}>
                  <Box sx={{ border: "1px solid #d0d0d0", borderRadius: "4px", p: 1, backgroundColor: "#f8f9fa", height: "100%" }}>
                    <Typography variant="body2" sx={{ fontWeight: "bold", fontSize: "0.7rem", color: "#333", mb: 0.3 }}>
                      Narration
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "0.75rem", color: "#555", lineHeight: 1.3, maxHeight: "40px", overflow: "hidden", textOverflow: "ellipsis" }}
                    >
                      {selectedVoucher?.remarks || "No remarks"}
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {/* DEBTOR DETAILS Header */}
              <Box
                sx={{
                  bgcolor: "#e3f2fd",
                  color: "#1a237e",
                  textAlign: "center",
                  py: 0.75,
                  border: "1px solid #bbdefb",
                  borderRadius: "4px",
                  mt: 2,
                }}
              >
                <Typography variant="subtitle1" sx={{ fontWeight: "bold", fontSize: "0.85rem" }}>
                  DEBTOR DETAILS
                </Typography>
              </Box>

              {/* Debtor Details Grid */}
              <Box sx={{ border: "1px solid #d0d0d0", borderRadius: "4px", overflow: "hidden", mt: 1 }}>
                {/* First Row */}
                <Box sx={{ display: "flex", borderBottom: "1px solid #d0d0d0", backgroundColor: "#f8f9fa" }}>
                  <Box sx={{ width: "50%", borderRight: "1px solid #d0d0d0", p: 1 }}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography variant="body2" sx={{ fontWeight: "bold", fontSize: "0.7rem", color: "#333", minWidth: "100px" }}>
                        Debtor
                      </Typography>
                      <Typography variant="body2" sx={{ fontSize: "0.75rem", color: "#555" }}>
                        : {selectedVoucher?.debtor?.company_name || "N/A"}
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{ width: "50%", p: 1 }}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography variant="body2" sx={{ fontWeight: "bold", fontSize: "0.7rem", color: "#333", minWidth: "100px" }}>
                        GST No
                      </Typography>
                      <Typography variant="body2" sx={{ fontSize: "0.75rem", color: "#555" }}>
                        : {selectedVoucher?.debtor?.gst || "N/A"}
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {/* Second Row */}
                <Box sx={{ display: "flex", borderBottom: "1px solid #d0d0d0" }}>
                  <Box sx={{ width: "50%", borderRight: "1px solid #d0d0d0", p: 1 }}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography variant="body2" sx={{ fontWeight: "bold", fontSize: "0.7rem", color: "#333", minWidth: "100px" }}>
                        Contact Name
                      </Typography>
                      <Typography variant="body2" sx={{ fontSize: "0.75rem", color: "#555" }}>
                        : {selectedVoucher?.debtor?.name || "N/A"}
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{ width: "50%", p: 1 }}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography variant="body2" sx={{ fontWeight: "bold", fontSize: "0.7rem", color: "#333", minWidth: "100px" }}>
                        PAN No
                      </Typography>
                      <Typography variant="body2" sx={{ fontSize: "0.75rem", color: "#555" }}>
                        : {selectedVoucher?.debtor?.pan || "N/A"}
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {/* Third Row */}
                <Box sx={{ display: "flex", borderBottom: "1px solid #d0d0d0" }}>
                  <Box sx={{ width: "50%", borderRight: "1px solid #d0d0d0", p: 1 }}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography variant="body2" sx={{ fontWeight: "bold", fontSize: "0.7rem", color: "#333", minWidth: "100px" }}>
                        Email
                      </Typography>
                      <Typography variant="body2" sx={{ fontSize: "0.75rem", color: "#555", wordBreak: "break-all" }}>
                        : {selectedVoucher?.debtor?.email || "N/A"}
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{ width: "50%", p: 1 }}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography variant="body2" sx={{ fontWeight: "bold", fontSize: "0.7rem", color: "#333", minWidth: "100px" }}>
                        Address
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ fontSize: "0.75rem", color: "#555", maxHeight: "35px", overflow: "hidden", textOverflow: "ellipsis" }}
                      >
                        : {selectedVoucher?.debtor?.address || "N/A"}
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {/* Fourth Row */}
                <Box sx={{ p: 1, backgroundColor: "#f8f9fa" }}>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Typography variant="body2" sx={{ fontWeight: "bold", fontSize: "0.7rem", color: "#333", minWidth: "100px" }}>
                      Phone No
                    </Typography>
                    <Typography variant="body2" sx={{ fontSize: "0.75rem", color: "#555" }}>
                      : {selectedVoucher?.debtor?.contact || "N/A"}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>

          {/* Modal Footer */}
          <Box
            sx={{
              p: { xs: 1, sm: 1.5 },
              bgcolor: "#f5f5f5",
              borderTop: "1px solid #e0e0e0",
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "space-between",
              alignItems: { xs: "stretch", sm: "center" },
              gap: 1,
              position: "sticky",
              bottom: 0,
              zIndex: 10,
            }}
          >
            {/* Edit Button */}
            <Button
              variant="outlined"
              color="primary"
              size="small"
              onClick={() => {
                if (selectedVoucher?.status !== "Approved") {
                  setPreviewModalOpen(false);
                  handleEditClick(selectedVoucher);
                }
              }}
              disabled={selectedVoucher?.status === "Approved"}
              startIcon={<Edit fontSize="small" />}
              sx={{
                minWidth: { xs: "100%", sm: 80 },
                fontSize: "0.75rem",
                py: 0.5,
              }}
            >
              Edit
            </Button>

            {/* Action Buttons */}
            <Box
              sx={{
                display: "flex",
                gap: 0.5,
                flexWrap: "wrap",
                justifyContent: { xs: "center", sm: "flex-end" },
              }}
            >
              {/* Close Button */}
              <Button
                variant="outlined"
                size="small"
                onClick={() => setPreviewModalOpen(false)}
                sx={{
                  minWidth: { xs: "45%", sm: 80 },
                  fontSize: "0.75rem",
                  py: 0.5,
                }}
              >
                Close
              </Button>

              {/* Status based buttons */}
              {selectedVoucher?.status === "Rejected" && (
                <Button
                  variant="contained"
                  color="success"
                  size="small"
                  onClick={() => handleOpenRemarkDialog("Approved")}
                  sx={{
                    minWidth: { xs: "45%", sm: 80 },
                    fontSize: "0.75rem",
                    py: 0.5,
                  }}
                >
                  Approve
                </Button>
              )}

              {selectedVoucher?.status === "Pending" && (
                <>
                  <Button
                    variant="contained"
                    color="error"
                    size="small"
                    onClick={() => handleOpenRemarkDialog("Rejected")}
                    sx={{
                      minWidth: { xs: "45%", sm: 80 },
                      fontSize: "0.75rem",
                      py: 0.5,
                    }}
                  >
                    Reject
                  </Button>
                  <Button
                    variant="contained"
                    color="success"
                    size="small"
                    onClick={() => handleOpenRemarkDialog("Approved")}
                    sx={{
                      minWidth: { xs: "45%", sm: 80 },
                      fontSize: "0.75rem",
                      py: 0.5,
                    }}
                  >
                    Approve
                  </Button>
                </>
              )}

              {selectedVoucher?.status === "Approved" && (
                <Chip
                  label="Approved"
                  color="success"
                  size="small"
                  sx={{ minWidth: 80, fontSize: "0.75rem", height: "32px" }}
                />
              )}

              {selectedVoucher?.status === "Rejected" && selectedVoucher?.status !== "Pending" && (
                <Chip
                  label="Rejected"
                  color="error"
                  size="small"
                  sx={{ minWidth: 80, fontSize: "0.75rem", height: "32px" }}
                />
              )}
            </Box>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={remarkModalOpen}
        onClose={() => setRemarkModalOpen(false)}
        aria-labelledby="remark-dialog-modal"
      >
        <Box sx={remarkModalStyle}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography
              id="remark-dialog-modal"
              variant="h6"
              sx={{
                color: actionType === "Approved" ? "#2e7d32" : "#d32f2f",
                fontWeight: "bold",
              }}
            >
              {actionType === "Approved" ? "Approve Voucher" : "Reject Voucher"}
            </Typography>
            <IconButton size="small" onClick={() => setRemarkModalOpen(false)}>
              <Close />
            </IconButton>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Voucher No: <strong>{selectedVoucher?.sales_number}</strong>
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              Are you sure you want to{" "}
              {actionType === "Approved" ? "approve" : "reject"} this voucher?
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="body2" sx={{ mb: 1, fontWeight: "bold" }}>
              Please enter a remark (required):
            </Typography>
            <TextField
              fullWidth
              multiline
              rows={3}
              value={remarkInput}
              onChange={(e) => setRemarkInput(e.target.value)}
              placeholder={`Enter reason for ${actionType === "Approved" ? "approval" : "rejection"
                }...`}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "&:focus-within": {
                    borderColor:
                      actionType === "Approved" ? "#4caf50" : "#f44336",
                  },
                },
              }}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
            }}
          >
            <Button
              variant="outlined"
              onClick={() => setRemarkModalOpen(false)}
              sx={{ minWidth: 100 }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color={actionType === "Approved" ? "success" : "error"}
              onClick={handleApproveReject}
              disabled={!remarkInput.trim()}
              sx={{ minWidth: 100 }}
            >
              Confirm
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default SalesVouchers;
